// extracted by mini-css-extract-plugin
module.exports = {"link":"AuthNav_link__X_mNY","activeLink":"AuthNav_activeLink__2X6zw"};